// @ts-nocheck
export const localeCodes =  [
  "it"
]
export const localeLoaders = {
  it: []
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/e777b66f" /* webpackChunkName: "config_i18n_46config_46js_e777b66f" */)
]
export const normalizedLocales = [
  {
    code: "it",
    site: "it",
    language: "it-IT",
    name: "Italiano"
  }
]
/** client **/

/** client-end **/